export default __webpack_public_path__ + "static/media/ESIRS_JTB_TIN.cd7a6d79.xlsx";